import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "aria-busy"]
const _hoisted_2 = {
  key: 0,
  class: "inline-block h-[1em] w-[1em] animate-spin rounded-full border-2 border-current border-t-transparent"
}
const _hoisted_3 = {
  key: 2,
  class: "inline-flex items-center"
}

import { computed } from 'vue'
import { neueButtonClasses } from '@/components/neue/neueButtonClasses'

export default {
  __name: 'NeueButton',
  props: {
  type: { type: String, default: 'primary' },
  size: { type: String, default: 'md' },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  fullWidth: { type: Boolean, default: false }
},
  emits: ['click'],
  setup(__props) {

const props = __props

const off = computed(() => props.disabled || props.loading || props.type === 'inactive')
const classes = computed(() => neueButtonClasses({ type: props.type, size: props.size, off: off.value }))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([classes.value, __props.fullWidth && 'w-full']),
    disabled: off.value,
    "aria-busy": __props.loading || undefined,
    onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('click', $event)))
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (!__props.loading)
      ? _renderSlot(_ctx.$slots, "icon-left", { key: 1 })
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (!__props.loading)
      ? _renderSlot(_ctx.$slots, "icon-right", { key: 3 })
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

}